<template>
  <div class="answered">
    <h3>You've answered this question!</h3>
    <a @click="back();" class="m-btn m-btn--left m-btn__secondary"><span class="m-btn m-btn__back" style="display:inline-block; margin-top: -0.4em;"></span>Go back</a>
  </div>
</template>

<script>
export default {
  methods: {
    back () {
      this.$router.go(-1)
    }
  },
  name: 'Answered'
}
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
.answered .m-btn__secondary {
  &:hover {
    background: #74babe;
  }
}
.m-btn__back {
  background-image: url(~@/assets/images/btns/black-triangle-back.png);
  height: 20px;
  width: 15px;
  background-repeat: no-repeat;
  background-size: cover;
  transform: translateY(2px);
  padding:0;
  margin:0 10px 0 0;
}

  @media (max-width: 899px) {
    .m-btn__back {
      height: 15px;
      width: 10px;
      margin:0 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Answered.vue